import { render, staticRenderFns } from "./dermoscopy.vue?vue&type=template&id=71e4a8c4&scoped=true"
import script from "./dermoscopy.vue?vue&type=script&lang=js"
export * from "./dermoscopy.vue?vue&type=script&lang=js"
import style0 from "./dermoscopy.vue?vue&type=style&index=0&id=71e4a8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e4a8c4",
  null
  
)

export default component.exports